export const SAVE = 'StandardVTCMedicalBenefitsTugo.SAVE';
export const VALUE_CHANGED = 'StandardVTCMedicalBenefitsTugo.VALUE_CHANGED';
export const LOAD = 'StandardVTCMedicalBenefitsTugo.VALUE_LOAD';
export const NEXT = 'StandardVTCMedicalBenefitsTugo.NEXT';
export const RESET = 'StandardVTCMedicalBenefitsTugo.RESET';

export const RESET_FORM_STATE = 'StandardVTCMedicalBenefitsTugo.RESET_FORM_STATE';

export const MEDICAL_EXPENSE_TYPES = {
  DOCTORS_VISIT: "Doctor's Visit",
  DIAGNOSTIC_TESTS: 'Diagnostic Tests',
  PRESCRIPTION_DRUGS: 'Prescription Drugs',
  AMBULANCE_SERVICES: 'Ambulance Services',
  HOSPITALIZATION: 'Hospitalization',
  ESSENTIAL_MEDICAL_APPLIANCES: 'Essential Medical Appliances',
  RETURN_OF_VEHICLE: 'Return of Vehicle',
  PRIVATE_DUTY_NURSING: 'Private Duty Nursing',
  FRACTURE_TREATMENT: 'Fracture Treatment',
  MATERNITY_BENEFITS: 'Maternity Benefits',
  PROFESSIONAL_SERVICES: 'Professional Services',
  DENTAL_SERVICES: 'Dental Services',
  EXPENSES_RELATED_TO_DEATH_REPATRIATION: 'Expenses Related to Death',
  ACCIDENTAL_DEATH_AND_DISMEMBERMENT_BENEFITS: 'Accidental Death and Dismemberment Benefits',
  OTHER_UNRELATED_BENEFIT: 'Other (unrelated to any benefit listed above)',
};

/** Provider types for Professional Services (Standard VTC). Used for form keys and claim-code mapping. */
export const PROFESSIONAL_SERVICES_PROVIDERS = {
  PHYSIOTHERAPIST: 'physiotherapist',
  CHIROPRACTOR: 'chiropractor',
  CHIROPODIST: 'chiropodist',
  OSTEOPATH: 'osteopath',
  PODIATRIST: 'podiatrist',
  ACUPUNCTURIST: 'acupuncturist',
  OPTOMETRIST: 'optometrist',
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.StandardVTCMedicalBenefits/constants.js